module.exports = __webpack_public_path__ + "static/media/WTBFBBookCover.b798294a.jpg";